<template>
	<header class="control-bar mt-2 mb-2">
		<div class="sponsor-section">
			<CountDownTimer
				:videoDuration="videoDuration"
				:currentTime="currentTime"
				:size="32"
				v-if="showCountDownTimer"
			/>
			<div class="divider" v-if="showCountDownTimer" />

			<slot name="provider-icon" v-if="showProviderIcon" />
			<div class="divider" v-if="showProviderIcon"></div>
			<p class="sponsor-title">
				<template v-if="$slots['action-items']">
					<slot name="action-items" />
				</template>
				<template v-else> {{ $t('WEBAPP_SPONSORED_TAG') }} </template>
			</p>
			<div class="divider" v-if="showCountdownText"></div>
			<p v-if="showCountdownText" class="countdown-text text-medium">
				{{ $t('WEBAPP_SR_VIDEO_PLAYS_IN') }} {{ secondsLeft }}s
			</p>
		</div>
		<div class="controls-section">
			<div class="control-button" aria-label="Volume" @click.stop="handleToggleMute">
				<img :src="volumeIcon" class="volume-icon" />
			</div>
			<div class="divider"></div>
			<button class="control-button" aria-label="PlayPause" @click.stop="handleTogglePlayPause">
				<img :src="playIcon" class="pause-icon" />
			</button>
		</div>
	</header>
</template>

<script setup lang="ts">
import CountDownTimer from '@/features/sponsored-recommendations/components/VideoCountdownTimer.vue';
import { computed } from 'vue';
const props = withDefaults(
	defineProps<{
		isMuted: boolean;
		isPaused: boolean;
		currentTime: number;
		videoDuration: number;
		showCountDownTimer?: boolean;
		showCountdownText?: boolean;
		showProviderIcon?: boolean;
	}>(),
	{
		isMuted: false,
	}
);

const emits = defineEmits(['toggleMute', 'togglePlayPause']);

const secondsLeft = computed(() => Math.ceil(Math.max(0, props.videoDuration - props.currentTime)));

const volumeIcon = computed(() => {
	const filename = props.isMuted ? 'volume-xmark' : 'volume-high';
	return `/${ASSETS_DIR}/img/sponsored-recommendation-assets/${filename}.svg`;
});

const playIcon = computed(() => {
	const filename = props.isPaused ? 'player-play' : 'player-pause';
	return `/${ASSETS_DIR}/img/sponsored-recommendation-assets/${filename}.svg`;
});

function handleToggleMute() {
	emits('toggleMute');
}

function handleTogglePlayPause() {
	emits('togglePlayPause');
}
</script>

<style scoped>
.control-bar {
	display: flex;
	padding: 24px 16px;
	height: 32px;
	justify-content: space-between;
	align-items: center;
}

.sponsor-section {
	display: flex;
	align-items: center;
	gap: 8px;
}

.sponsor-section p {
	margin-top: 0;
	margin-bottom: 0;
	line-height: 1;
}

.sponsor-title {
	font-family: 'Lato', sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 900;
	line-height: 16px;
	letter-spacing: 0.21px;
}
.timer {
	width: 32px;
	padding: 8px;
	border-radius: 32px;
	border: 1px solid #fbc500;
	color: #d2d3d5;
	font-family: 'Lato', sans-serif;
	font-size: 14px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.21px;
}

.divider {
	width: 1px;
	height: 8px;
	background-color: #353a42;
}

.controls-section {
	display: flex;
	align-items: center;
	gap: 8px;
}

.control-button {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.control-button:focus {
	outline: 2px solid #fbc500;
	border-radius: 4px;
}

.volume-icon,
.pause-icon {
	width: 24px;
	height: 24px;
}

@media (max-width: 640px) {
	.control-bar {
		padding: 0 12px;
	}

	.timer {
		width: 28px;
		padding: 6px;
	}

	.sponsor-logo {
		width: 50px;
		height: 20px;
	}
}

@media (max-width: 400px) {
	.countdown-text {
		font-size: 12px;
		line-height: 14px;
		letter-spacing: 0.18px;
	}

	.sponsor-title {
		font-size: 14px;
		line-height: 14px;
		letter-spacing: 0.18px;
	}

	.volume-icon,
	.pause-icon {
		width: 18px;
		height: 18px;
	}
}
</style>
